import { DateRangeSelectorDataType } from '../../components/Shared/Filters';
import { PositionFilterDataType } from '../../components/Shared/Filters/PositionFilter';
import { TeamSelectorDataType } from '../../components/Shared/Filters/TeamsSelector';
import { TimeSinceFilterData } from '../../components/Shared/Filters/TimeSinceFilter';
import { PeriodTypeInlineMultiSelectorDataType } from '../../components/Shared/Filters/PeriodTypeInlineMultiSelector';
import { PositionLacrosseFilterData } from '../../components/Shared/Filters/PositionLacrosseFilter/types';
import { SimpleMultiSelectorData } from '../../components/Shared/Filters/SimpleMultiSelector/types';
import { SimpleSelectorItem } from '../../components/Shared/Filters/SimpleSelector/types';
import { HealthTimeSliderFilterData } from '../../components/Shared/Filters/HealthTimeSlider/types';
import { YearSeasonFilterDataType } from '../../components/Shared/Filters/YearSeasonFilter/types';
import { RangeDate } from '../../config/commonTypes';
import { FILTER_GLOBAL_KEYS, FILTER_KEYS, NFL } from '../../config/constants';
import { ZoneTypeFilterData } from '../../components/Shared/Filters/ZoneTypeFilter';
import {
  EventsFilterData,
  FlightTypeFilterData,
  IntensitiesSimpleMultiSelectorData,
  LeagueSimpleSelectorData,
  PeriodsSimpleMultiSelectorData,
  PlayTypeSimpleSelectorData,
  QuartersSimpleMultiSelectorData,
  SeasonSimpleSelectorData,
  SeasonYearSelectorData,
  StatusSimpleMultiSelectorData,
  TargetedReTrackFilterData,
  ViewDataFilterData,
  YearSelectorData
} from '../../components/Shared/Filters/type';
import { ShowDistanceGraphData } from '../../components/Shared/Filters/ShowDistanceGraph';
import { TeamsMultiSelectorData } from '../../components/Shared/Filters/TeamsMultiSelector/types';
import { VenueSelectorData } from '../../components/Shared/Filters/VenueSelector/types';
import { CustomTableFilterDataType } from 'components/Shared/Filters/CustomTableFilter';
import { PlayerFilterDataType } from 'components/Alerting/Filter';

export enum FiltersAction {
  CHANGE_SELECTED_FILTERS_PROPERTY = 'CHANGE_SELECTED_FILTERS_PROPERTY',
  REPLACE_TEAMS_LIST = 'REPLACE_TEAMS_LIST',
  REPLACE_ALL_SEASON_WEEKS = 'REPLACE_ALL_SEASON_WEEKS',
  REPLACE_VENUES = 'REPLACE_VENUES',
  UPDATE_PRACTICES_DATE_RANGE_SELECTOR = 'UPDATE_PRACTICES_DATE_RANGE_SELECTOR'
}

type ChangeSelectedFiltersType = {
  type: FiltersAction.CHANGE_SELECTED_FILTERS_PROPERTY;
  property: FilterDataTypes;
  filterKey: string;
  scope: string;
  firstTime?: true;
}

type UpdatePracticesDateRangeSelectorType = {
  type: FiltersAction.UPDATE_PRACTICES_DATE_RANGE_SELECTOR;
  teamId: number;
  yearSeason: number;
  dataPractices: any;
}

// state.filters.teams
export type GlobalFilterTeamType = { teamCityState: string, teamId: string, teamNick: string, teamFullName: string, teamAbbrName: string };
export type GlobalFilterTeamsDivisionType = {
  name: string;
  teams: GlobalFilterTeamType[];
}

export type GlobalFilterTeamsNflType = {
  [key: string]: GlobalFilterTeamsDivisionType[];
}

export type GlobalFilterTeamsNcaaType = GlobalFilterTeamType[];

export type GlobalFilterTeamsType = {
  nfl: GlobalFilterTeamsNflType;
  ncaa: GlobalFilterTeamsNcaaType;
}

type ReplaceTeamsListType = {
  type: FiltersAction.REPLACE_TEAMS_LIST;
  teamsGroups: GlobalFilterTeamsType;
}

// state.filter.WEEKS
export type Week = {
  weekNameAbbr: string;
  weekName: string;
  ts: number;
  week: number;
  startOfWeek: string;
  endOfWeek: string;
}

export type Month = {
  startOfMonth: string;
  endOfMonth: string;
  monthName: string;
}

export type SeasonWeeks = {
  [key in number | string]: Week[];
};

type ReplaceAllSeasonWeeksType = {
  type: FiltersAction.REPLACE_ALL_SEASON_WEEKS;
  weeks: SeasonWeeks;
}

// state.filters.venues
export type VenueType = {
  teamId: string;
  siteId: string | number;
  siteName: string;
  type: string;
  league: string;
  label: string;
  teamAbbr: string;
  siteCityAbbr: string;
  hosts: {
    primary: {
      ip: string;
    };
  };
}

export type GlobalFilterVenuesType = {
  ncaaFbs: { practice: VenueType[], game: VenueType[] };
  [NFL]: { practice: VenueType[], game: VenueType[] };
  mlax: { practice: VenueType[] };
}

type ReplaceVenuesType = {
  type: FiltersAction.REPLACE_VENUES;
  venues: GlobalFilterVenuesType;
}
//COMBINE DRILLS TYPE
export type CombineDrillOptionsType={
  drillType:string, drill:string
}

export type CombineDrillsType={
    groupSelected: string,
    options: CombineDrillOptionsType[]
  }[]


export type FiltersActionTypes =
  ChangeSelectedFiltersType
  | ReplaceTeamsListType
  | ReplaceAllSeasonWeeksType
  | ReplaceVenuesType
  | UpdatePracticesDateRangeSelectorType;

export type FiltersGlobalParams = {
  [FILTER_GLOBAL_KEYS.WEEKS]?: SeasonWeeks;
  [FILTER_GLOBAL_KEYS.TEAMS]?: GlobalFilterTeamsType;
  [FILTER_GLOBAL_KEYS.VENUES]?: GlobalFilterVenuesType;
  [FILTER_GLOBAL_KEYS.PRACTICES_DATE_RANGE_SELECTOR]?: { [key: string]: { [key: number]: any } };
}

export type FiltersScopedState = {
  [FILTER_KEYS.ZONE_TYPE]?: ZoneTypeFilterData;
  [FILTER_KEYS.POSITIONS]?: PositionLacrosseFilterData; // POSITION_LACROSSE.filterKey
  [FILTER_KEYS.PERIODS]?: PeriodsSimpleMultiSelectorData;
  [FILTER_KEYS.QUARTER]?: QuartersSimpleMultiSelectorData;
  [FILTER_KEYS.DATE_RANGE]?: DateRangeSelectorDataType<Week> | YearSeasonFilterDataType<RangeDate>;
  [FILTER_KEYS.TIME_SLIDER]?: HealthTimeSliderFilterData;
  [FILTER_KEYS.PERIOD_TYPE]?: PeriodTypeInlineMultiSelectorDataType;
  [FILTER_KEYS.SHOW_DISTANCE_GRAPHS]?: ShowDistanceGraphData | null; // if is null not show the distance graphs
  [FILTER_KEYS.TEAM_IDS]?: TeamsMultiSelectorData;
  [FILTER_KEYS.TEAM_ID]?: TeamSelectorDataType;
  [FILTER_KEYS.SIMPLE_LEAGUE]?: LeagueSimpleSelectorData;
  [FILTER_KEYS.LEAGUE]?: LeagueSimpleSelectorData;
  [FILTER_KEYS.TIME_SINCE_MAX]?: TimeSinceFilterData;
  [FILTER_KEYS.INTENSITY]?: IntensitiesSimpleMultiSelectorData;
  [FILTER_KEYS.SEASON]?: SeasonSimpleSelectorData;
  [FILTER_KEYS.YEAR]?: YearSelectorData;
  [FILTER_KEYS.VENUE]?: VenueSelectorData;
  [FILTER_KEYS.SEASON_YEAR]?: SeasonYearSelectorData;
  [FILTER_KEYS.EVENTS]?: EventsFilterData;
  [FILTER_KEYS.PLAY_TYPE]?: PlayTypeSimpleSelectorData;
  [FILTER_KEYS.VIEW]?: ViewDataFilterData;
  [FILTER_KEYS.VIEW_LIVE]?: ViewDataFilterData;
  [FILTER_KEYS.TARGETED_RETRACK]?: TargetedReTrackFilterData;
  [FILTER_KEYS.FLIGHT_TYPE]?: FlightTypeFilterData;
  [FILTER_KEYS.CUSTOM_TABLE]?: CustomTableFilterDataType;
  [FILTER_KEYS.CUSTOM_LIVE_TABLE]?: CustomTableFilterDataType;
  [FILTER_KEYS.PLAYERS_ALERT]?:PlayerFilterDataType;
  [FILTER_KEYS.STATUS_TRACKING]?:StatusSimpleMultiSelectorData;
}

export type UseFiltersState = FiltersGlobalParams & FiltersScopedState;

export type FiltersState = FiltersGlobalParams & { [key: string]: FiltersScopedState };

export type FilterDataTypes =
  | ZoneTypeFilterData
  | ShowDistanceGraphData
  | DateRangeSelectorDataType<Week>
  | YearSelectorData
  | PositionFilterDataType
  | TeamSelectorDataType
  | TimeSinceFilterData
  | DateRangeSelectorDataType<string>
  | PeriodTypeInlineMultiSelectorDataType
  | PositionLacrosseFilterData
  | SimpleMultiSelectorData
  | SimpleSelectorItem
  | HealthTimeSliderFilterData
  | LeagueSimpleSelectorData
  | boolean
  | YearSeasonFilterDataType<RangeDate>
  | CustomTableFilterDataType;
